import Image from "next/image"

const Thankyou = ({ successMsg }: { successMsg: string }) => {
	return (
		<div className={`thank-you lg:w-[43.75rem]`}>
			<div className="thankyou-container">
				<div className="thankyou-contact flex flex-col items-center justify-center gap-4 ">
					<div className="icon-container relative w-[3.7rem] h-[3.7rem] bg-oBlue-150  rounded-full">
						<Image
							src="/images/check.svg"
							fill
							alt="check icon"
							className="p-4"
						/>
					</div>
					<h3 className="thank-you-header el font-national text-h5 ">Thank You!</h3>
					<p className="el font-bodyM text-center ">{successMsg}</p>
				</div>
			</div>
		</div>
	)
}

export default Thankyou
